import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { map } from 'rxjs/operators';

export class BusinessDomainConfig {
    value: string;
    color: string;
    translatedValue?: string;
}

export class VisibilityRule {
    Id: string;
    TargetType: string;
    TaskType: VisibilityRuleTaskType[] = [];
    HiddenObject: VisibilityRuleHiddenObject[] = [];
    ObjectType: string;
}

export class VisibilityRuleTaskType {
    TaskType: string;
    Id: string;
}

export class VisibilityRuleHiddenObject {
    HiddenObject: string;
    Id: string;
}


@Injectable()
export class BusinessDomainService {

    private backendUri: string = '';
    private customerAdminUri: string = '';

    constructor(private config: AppConfig,
        private http: HttpClient) {
        this.backendUri = this.config.backendIwmUri + 'Api/';
        this.customerAdminUri = this.config.backendIwmUri + 'CustomerAdminApi/';
    }

    private readonly businessDomains: BusinessDomainConfig[] = [
        { value: 'None', color: 'transparent' },
        { value: 'Electricity', color: '#000000' },
        { value: 'DistrictHeating', color: '#000000' },
        { value: 'Telecommunications', color: '#000000' },
        { value: 'Water', color: '#000000' },
        { value: 'DistrictCooling', color: '#000000'},
        { value: 'Municipality', color: '#000000'},
    ];

    public getBusinessDomainByValue(value: string): BusinessDomainConfig {
        return this.businessDomains.find(o => o.value === value) ?? this.businessDomains[0];
    }

    public getBusinessDomains(): BusinessDomainConfig[] {
        return this.businessDomains.map(o => ({ ...o }));
    }

    public getHiddenBusinessDomains(targetType: string, taskType: string): Observable<VisibilityRule[]> {
        let url = '';
        if (targetType === 'Task') {
            url = `${this.customerAdminUri}HideObjects?$expand=TaskType, HiddenObject&$filter=(TargetType eq '${targetType}' and (TaskType/any(c: c/TaskType eq '${taskType}' ) eq true or TaskType/any() eq false))`;
        } else {
            url = `${this.customerAdminUri}HideObjects?$expand=HiddenObject&$filter=TargetType eq '${targetType}'`;
        }
        return this.http.get<{ value: VisibilityRule[] }>(url)
            .pipe(map(o => o.value.map(item => {
                return {
                    ...item
                }
            }))
            );
    }
}
